import React, { useEffect } from "react";
import styled from "styled-components";
import Table from "./Table";
import Icons from '../../Icons/icons';
import { Icon } from "react-icons-kit";
import { IconsPicker } from '../../../libs/components/IconsPicker';
import { ic_delete } from "react-icons-kit/md/ic_delete";

const Styles = styled.div`
  padding: 0.1rem;

  table {
    width:100%;
    background-color: white;
    border-spacing: 0;
    border: 1px solid black;
    color:black;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const getOptionsFromIcons = (icons) => {
  return Object.keys(icons).map(iconKey => {
    return {
      value:iconKey,
      icon:icons[iconKey]
    }
  });
}

export default function ActionsTable({ actions, onDelete , onChange , onRowUpdate}) {

  //const records = React.useMemo(()=>actions,[]);
  const options = getOptionsFromIcons(Icons);
  const getOption = (value) => {
    console.log(value)
    return options.find(option => option.value === value);
  }
  console.log(options)
  console.log('iconzzzz')
  console.log(Object.keys(Icons));
  const columns = React.useMemo(
    () => [
      {
        Header: "",
        id: "delete",
        accessor: (str) => "delete",
        Cell: (tableProps) => (
          <button onClick={() =>{
            console.log(`clicked the f***ing button`);
            //const actionId = tableProps.
            onDelete(tableProps.row.original.id,tableProps.row.original.position);
          }}>del</button>
        )
      },
      {
        Header: "Actions",
        columns: [
          {
            Header:'icon',
            accessor: "icon",
            width:150,
            Cell: (cell) => (<IconsPicker options={options} value={getOption(cell.value)} onSelectionChanged={(value)=>{
              console.log(`value`);
              console.log(value);
              console.log(cell);
              const original = cell.row.original;
              const values = cell.values;
              const action = Object.assign({},original,values,{icon:value.value});
              console.log(action);  
              onRowUpdate(action);
            }}></IconsPicker>)
          },
          {
            Header: "Description",
            accessor: "description",
            width:100
          },
          {
            Header: "Link",
            accessor: "link",
            width:200
          }
        ]
      }
    ],
    []
  );

  return (
    <Styles>
      <Table columns={columns} data={actions} updateMyData={onChange} onRowUpdate={onRowUpdate}/>
    </Styles>
  );
}
